import instance from './axiosInstance';
const routerPrefix = '/customerCheck';

/*
  Request header has a param X-cid, which tells IF Server to validate the active customer
  IF Server returns 204 for success and 205 for failure and client can do a reload of the 
  page to fetch the data of active customer
*/
export function checkActiveCustomer(options = {}) {
  return instance.get(`${routerPrefix}`, options);
}
